import { gql } from "@apollo/client";

export const GET_INITIAL_CALL_INFO_MINIMUM = gql`
  query GET_INITIAL_CALL_INFO_MINIMUM($incidentId: ID!, $originatorId: ID!) {
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      id
      address {
        __typename
        id
        name
      }
      classification {
        id
        name
        oriId
        position
      }
      incidentNumber
      officerIncidentSpecifics {
        id
        dispatchedAt
        enrouteAt
        officer {
          id
        }
      }
      ori {
        id
        abbreviation
        agencyType
        oriName
        requireDrugType
        poldOptOut
      }
    }
  }
`;
